<template>
  <div class="drawer__header" data-js="get-height">
    <v-layout align-center justify-start>
      <v-btn
        v-if="history.length > 1"
        icon
        @click="goBack"
      >
        <v-icon color="gray-6">keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        <span
          v-if="isValidObject(data) && data.numericalId"
          class="drawer__title text--ellipsis"
          style="font-size: 13px;"
        >
          Ref: {{ moment(data.periodStartDate).format('DD/MM') }}
          {{ $t('Common.to') }}
          {{
            data.executionDateOpt
              ? moment(data.executionDateOpt).subtract(1, 'd').format('DD/MM/YYYY')
              : '-'
          }}
        </span>

        <span v-else class="drawer__title text--ellipsis">
          {{ $t('Components.FinancialInvoicesHistory.openInvoice') }}
        </span>
      </v-flex>
    </v-layout>

    <div>
      <v-tooltip
        v-if="(hasRole('profiles', 'ROLE_ADMINISTRATOR') || hasRole('profiles', 'ROLE_FINANCIAL_ADMIN')) &&
          (data.paymentStatus === 'INVOICE_SENT' || data.paymentStatus === 'AUTHORISED')"
        top
        slot="activator"
        max-width="172px"
      >
        <v-btn
          :to="{
            name: 'InvoiceExtendDueDate',
            params: {
              invoiceId: data.id,
              dueDateOpt: formatDate(data.dueDateOpt)
            }
          }"
          slot="activator"
          flat
          icon
          class="dropdown-actions__activator gray-6--text mx-0"
          @click.prevent
        >
          <v-icon color="gray-6">event</v-icon>
        </v-btn>
        <span>{{ $t('Components.FinancialInvoicesHistory.tooltipExtendExpiration') }}</span>
      </v-tooltip>

      <v-tooltip
        v-if="(hasRole('profiles', 'ROLE_ADMINISTRATOR') || hasRole('profiles', 'ROLE_FINANCIAL_ADMIN')) && data.paymentStatus === 'LATE'"
        top
        slot="activator"
        max-width="172px"
      >
        <v-btn
          :to="{
            name: 'InvoiceExtendDueDate',
            params: {
              invoiceId: data.id,
              dueDateOpt: formatDate(data.dueDateOpt)
            }
          }"
          slot="activator"
          flat
          icon
          class="dropdown-actions__activator gray-6--text mx-0"
          @click.prevent
        >
          <v-icon color="gray-6">receipt</v-icon>
        </v-btn>
        <span>{{ $t('Components.FinancialInvoicesHistory.tooltipReissueBillet') }}</span>
      </v-tooltip>

      <FinancialDropdownActions
        v-if="hasRole('financial', 'ROLE_GET_ORDER_DOCUMENTS_URL') && isValidObject(data) && data.numericalId"
        :files="data.documents"
        :tooltipText="getTooltipText(data.paymentStatus)"
        tooltip
        left
      />

      <v-tooltip
        v-else
        top
        slot="activator"
        max-width="172px"
      >
        <v-btn
          v-if="hasRole('profiles', 'ROLE_ADMINISTRATOR')"
          :to="{ name: 'FinancialAdjustments' }"
          slot="activator"
          flat
          icon
          class="dropdown-actions__activator gray-6--text mx-0"
          @click.prevent
        >
          <v-icon color="gray-6">local_atm</v-icon>
        </v-btn>
        <span>{{ $t('Components.FinancialInvoicesHistory.financialAdjustmentsTooltip') }}</span>
      </v-tooltip>

      <v-btn icon @click="close">
        <v-icon color="gray-6">close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'libs/moment'
import { mapActions } from 'vuex'
import { hasRole } from 'utils/functions'
import { isValidObject } from 'corp-front-vue-commons/src/utils/functions'
import FinancialDropdownActions from 'components/pages/newBilling/FinancialDropdownActions'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    data: {
      type: Object
    }
  },
  components: {
    FinancialDropdownActions
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.financial.header'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    isValidObject (val) {
      return isValidObject(val)
    },

    goBack () {
      this.$emit('goBack')
    },

    close () {
      this.$emit('close')
    },

    formatDate (dueDateOpt, format = 'x') {
      return moment(dueDateOpt).format(format)
    },

    getTooltipText (paymentStatus) {
      if (paymentStatus === 'AUTHORISED' || paymentStatus === 'INVOICE_SENT') {
        return this.$t(`${this.namespace}.tooltipTextInvoiceSent`)
      }

      if (paymentStatus === 'LATE') {
        return this.$t(`${this.namespace}.tooltipTextLate`)
      }

      if (paymentStatus === 'EXTEND') {
        return this.$t(`${this.namespace}.tooltipTextExtended`)
      }

      return null
    }
  }
}
</script>
